// /* ------------------------------------------------------------------
//   File: HeroSection.jsx
//   Author: Engr. Shaffa K. Kokro Jr. - CEO, Accend Holdings Ltd.
//   Last Modified: 2026-07-20
// ------------------------------------------------------------------ */

// // Purpose:
// //   - Renders the homepage hero section.
// //   - Introduces Accend Holdings' core positioning and primary user actions.

// import { Link } from "react-router-dom";
// import { routesConfig } from "../../app/config/routesConfig";
// import Button from "../../shared/components/ui/Buttons";
// import "./HeroSection.css";

// function HeroSection() {
//   return (
//     <section className="hero-section l-section l-section--base">
//       <div className="hero-section__overlay"></div>
//       <div className="hero-section__container l-container l-container--wide">
//         <div className="hero-section__content l-stack l-stack--md">
//           <h1 className="hero-section__title u-type-display ">
//             Engineering Africa's Next Enterprises
//           </h1>

//           <p className="hero-section__text u-type-body l-measure l-measure--narrow">
//             Accend Holdings is a multinational group building the companies, platforms, 
//             and systems that are transforming African potential into enduring enterprises.
//           </p>

//           <div className="hero-section__actions l-cluster l-cluster--spaced">
//             <Button
//               as={Link}
//               size="md"
//               variant="outline"
//               to={routesConfig.contact}
//               className="hero-section__button hero-section__button--primary"
//             >
//               Contact our group
//             </Button>
            
//             {/* <Button
//               as={Link}
//               size="md"
//               variant="outline"
//               to={routesConfig.contact}
//               className="hero-section__button hero-section__button--primary"
//             >
//               Contact our group
//             </Button> */}
            
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default HeroSection;

/* ------------------------------------------------------------------ 
  File: HeroSection.jsx 
  Author: Engr. Shaffa K. Kokro Jr. - CEO, Accend Holdings Ltd. 
  Last Modified: 2026-09-08
------------------------------------------------------------------ */ 
 
// Purpose: 
//   - Renders the homepage hero section. 
//   - Introduces Accend Holdings' core positioning and primary user actions.
//   - Uses a looping background video with an image fallback.
 
import { Link } from "react-router-dom"; 
import { routesConfig } from "../../app/config/routesConfig"; 
import Button from "../../shared/components/ui/Buttons";

import heroVideo from "../../assets/videos/accend-corporate-video-1.mp4";
import heroPoster from "../../assets/images/__white-bridge-over-calm-lake__.jpg";

import "./HeroSection.css"; 
 
function HeroSection() { 
  return ( 
    <section className="hero-section l-section l-section--base">

      {/* Background Video */}
      <video
        className="hero-section__video"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        poster={heroPoster}
        aria-hidden="true"
        // controlsList="nodownload"
        // disablePictureInPicture
        // onContextMenu={(e) => e.preventDefault()}
      >
        <source src={heroVideo} type="video/mp4" />
      </video>

      {/* Overlay */}
      <div className="hero-section__overlay" aria-hidden="true" />

      {/* Content */}
      <div className="hero-section__container l-container l-container--wide"> 
        <div className="hero-section__content l-stack l-stack--md"> 
          
          <h1 className="hero-section__title u-type-display"> 
            Engineering Africa's Next Enterprises 
          </h1> 
 
          <p className="hero-section__text u-type-body l-measure l-measure--narrow"> 
            Accend Holdings is a multinational group building the companies,
            platforms, and systems that are transforming African potential
            into enduring enterprises.
          </p> 
 
          <div className="hero-section__actions l-cluster l-cluster--spaced"> 
            <Button 
              as={Link} 
              size="md" 
              variant="outline" 
              to={routesConfig.contact} 
              className="hero-section__button hero-section__button--primary" 
            > 
              Contact our group 
            </Button> 
          </div>

        </div> 
      </div> 
    </section> 
  ); 
} 
 
export default HeroSection;